export default "__VITE_ASSET__CTGSpm4t__"